import { useEffect } from 'react';
import { useLocation } from 'react-router';

// TODO: extracto a client-specific constant
const stickyHeaderHeight = 140;

export const useGlobalScrollEvents = () => {
  const location = useLocation();

  useEffect(() => {
    const anchorHash = decodeURIComponent(window.location.hash.replace('#', ''));

    if (anchorHash) {
      // Function to scroll to the anchor
      const scrollToAnchor = () => {
        const targetElement = document.getElementById(anchorHash);
        if (targetElement) {
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - stickyHeaderHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth', // Smooth scrolling
          });
          return true; // Successfully scrolled
        }
        return false; // Element not found
      };

      // Try immediate scroll first
      if (!scrollToAnchor()) {
        // If element not found immediately, wait for DOM to be ready
        // This handles the case when page is reloaded with a hash
        const timeoutId = setTimeout(() => {
          scrollToAnchor();
        }, 100);

        // Also try when DOM content is fully loaded (for page reloads)
        if (document.readyState === 'loading') {
          const handleLoad = () => {
            scrollToAnchor();
            document.removeEventListener('DOMContentLoaded', handleLoad);
          };
          document.addEventListener('DOMContentLoaded', handleLoad);

          // Cleanup
          return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('DOMContentLoaded', handleLoad);
          };
        }

        // Cleanup timeout
        return () => clearTimeout(timeoutId);
      }
    }
  }, [location]);
};
